import React from "react";
import ReporteProductos from "../components/ReporteProductos";

const InformeProductos = () => {
  return (
    <>
      <ReporteProductos />
    </>
  );
};

export default InformeProductos;